export default {
    "title": "Administration panel / Users",
    "description": "List of users currently registered",
    "usersTableHeader": "Total: <0>{{count}}</0> | Active: <0>{{countActive}}</0> | Inactive: <0>{{countInactive}}</0> | Pending: <0>{{countPending}}</0>",
    "usersTableColumns": {
        "user_name": "Name and surnames",
        "userType": "Type",
        "email": "Email",
        "date": "Discharge date",
        "client": "Client",
        "emailSent": "Email sent?",
        "state": "State"
    },
    "popover": {
        "edit": "Edit",
        "activate": "Activate",
        "deactivate": "Deactivate",
        "email": "Send email",
        "delete": "Delete",
        "changePassword": "Change password"
    },
    "newUserDialog": {
        "title": "Create user",
        "input": {
            "name": "Name *",
            "placeholder_name": "New user name",
            "surname": "Surnames",
            "placeholder_surname": "New user surnames",
            "email": "Email *",
            "placeholder_email": "New user email",
            "type": "Type *",
            "clients": "Client *",
            "cancel": "Cancel"
        }
    },
    "editUserDialog": {
        "title": "Edit user",
        "text1": "Type of user:",
        "text2": "Client:",
        "input": {
            "name": "Name",
            "placeholder_name": "Edit user name",
            "surnames": "Surnames",
            "placeholder_surname": "Edit surnames",
            "email": "Email",
            "cancel": "Cancel",
            "save": "Save"
        }
    },
    "deactivateUserDialog": {
        "title": "Deactivate user",
        "userType": "Type of user:",
        "client": "Client:",
        "text1": "The user is going to be deactivated, are you sure?",
        "text2": "The user will not be able to connect or take any action.",
        "deactivate": "Deactivate"
    },
    "activateUserDialog": {
        "title": "Activate user",
        "userType": "Type of user:",
        "client": "Client:",
        "text1": "The user is going to be activated, are you sure?",
        "text2": "The user will be able to connect and perform the actions according to his profile and his visibility.",
        "activate": "Activate"
    },
    "deleteUserDialog": {
        "title": "Delete user",
        "userType": "Type of user:",
        "client": "Client:",
        "text1": "The user is going to be deleted, are you sure?",
        "text2": "The user will not appear, and it will no longer be possible to agree or perform any action in the application.",
        "delete": "Delete"
    },
    "updatePasswordUserDialog": {
        "requirements": {
            "title": "Minimum requirements for the new password:",
            "characters": "At least 6 characters",
            "lower": "A lowercase letter",
            "upper": "A uppercase letter",
            "number": "A numeric digit",
            "special": "A special character"
        },
        "inputs": {
            "newPassword": "New password *",
            "verifyNewPassword": "Re-enter password *"
        },
        "validations": {
            "currentPassword": "The current password is required",
            "password": "Not all requirements are met",
            "verifyPassword": "Passwords do not match"
        }
    },
    "stateTag": {
        "active": "Active",
        "inactive": "Inactive",
        "pending": "Pending"
    },
    "sendEmail": "Send email to user",
    "funcWithAccess": {
        "label": "Functionalities with access",
        "invoices": "Invoices",
        "deliveryNotes": "Delivery Notes",
        "stock": "Stock",
        "technicalsSheets": "Technicals sheets",
        "activeOrders": "Active orders",
        "showStats": "Show stats",
        "documentations": "Documentation",
        "chat": "Chat",
        "transportation": "Transportation",
    },
    "userType": {
        "admin": "Admin",
        "client": "Client"
    },
    "userTypePlaceholder": "Type of user",
    "tooltip": {
        "newUserSendWelcomeEmail": "If you check this option, a welcome email will be sent to the user when creating it. If you decide not to send him the email now, you can send it to him later.",
        "updateUserSendEmail": "If you check this option, an email will be sent to the user when updating it. If you decide not to send him the email now, you can send it to him later."
    },
    "toaster": {
        "success": {
            "createUser": "User created successfully"
        }
    }
};